import type { MetaInfo } from 'vue-meta';

export const getMetaInfo = (page: any, isNoIndex: boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
  }
  if (page?.__typename === "CategoryTree" || page?.__typename === "CmsPage") {
    if (page?.meta_description) {
      seoTags.meta.push({
        hid: 'description',
        name: 'description',
        content: page.meta_description,
      });
    } else if (page?.identifier === 'home') {
      seoTags.meta.push({
        hid: 'description',
        name: 'description',
        content: page.title,
      });
    } else {
      seoTags.meta.push({
        hid: 'description',
        name: 'description',
        content: 'hhip',
      });
    }
  } else {
    if (page?.description.html) {
      seoTags.meta.push({
        hid: 'description',
        name: 'description',
        content: page.description.html,
      });
    } else {
      seoTags.meta.push({
        hid: 'description',
        name: 'description',
        content: 'Wide selection of tooling and accessories for the manufacturing and metalworking industries. We offer quality inspection, measuring, cutting, power, and hand tools.',
      });
    }
  }

  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  } else if (page?.title || page?.name) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.title || page?.name
    });
  } else {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: 'tools, metalworking tools, machine tool accessories, cutting tools, solid carbide, indexable, high speed steel, measuring, inspection tools, Metal Working, inspection, Accessories, die supplies, abrasives, end mills, drills, work holding',
    });
  }
  
  seoTags.meta.push({
    name: 'robots',
    content: 'INDEX, FOLLOW',
  });

  if (page?.title || page?.name) {
    seoTags.meta.push({
      hid: 'title',
      name: 'title',
      content: page?.title || page?.name,
    });
  }
  return seoTags;
};
